import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import rootReducer from './root-reducers';

// One-shot cleanup: redux-persist used to write a `persist:session` blob to
// localStorage that included the previous user's access tokens, agencyId,
// and selectedLocation. We dropped redux-persist (auth is owned by Auth0,
// the rest is recomputed on every bootstrap), so any leftover blob from a
// prior version of the app is dead weight and a cross-user-leak hazard.
// This runs once on every app load and is cheap.
if (typeof window !== 'undefined' && window.localStorage) {
    try {
        window.localStorage.removeItem('persist:session');
    } catch (e) {
        // localStorage can throw in private-mode / quota-exceeded scenarios.
        // Failing to clear is non-fatal — there's nothing else relying on it.
    }
}

const middleware = [thunk];

const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(...middleware))
);

export { store };
